import {useArrivalContext} from 'src/context/ArrivalContext';
import {DropinModalHD} from './dropin-modal-hd/DropinModalHD';
import {DropinModalInitial} from './dropin-modal-initial/DropinModalInitial';
import {DropinModalPeople} from './dropin-modal-people/DropinModalPeople';
import {DropinModalCompleted} from './dropin-modal-completed/DropinModalCompleted';
import './DropinModal.scss';

interface DropinModalProps {
    onClose?: VoidFunction;
}

export function DropinModal({onClose}: DropinModalProps) {
    const {dataState} = useArrivalContext();
    const {step} = dataState;

    const stepComponent = () => {
        switch (step) {
            case 'initial':
                return <DropinModalInitial />;
            case 'people':
                return <DropinModalPeople />;
            case 'hd':
                return <DropinModalHD />;
            case 'completed':
                return <DropinModalCompleted onClose={onClose} />;
        }
    };

    return <div className='arrival-dropin-component'>{stepComponent()}</div>;
}
